/**
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
'use strict';

module.exports = {
    BaseStore: require('./BaseStore'),
    connectToStores: require('./connectToStores'),
    createStore: require('./createStore'),
    FluxibleComponent: require('./FluxibleComponent'),
    FluxibleMixin: require('./FluxibleMixin'),
    provideContext: require('./provideContext')
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/fluxible/addons/index.js
 ** module id = 415
 ** module chunks = 0
 **/